(function () {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  // Keep this in sync with the breakpoint where base.css makes .page-wrapper
  // the actual scroll container.
  const desktop = window.matchMedia('(min-width: 990px)');


  window.disablePageScroll = function () {
    document.documentElement.setAttribute('scroll-lock', '');
    window.tncLenis?.stop();
  };

  window.enablePageScroll = function () {
    document.documentElement.removeAttribute('scroll-lock');
    window.tncLenis?.start();
  };

  function resizeLenis() {
    window.tncLenis?.resize();
  }

  function initLenis() {
    if (reducedMotion.matches || typeof window.Lenis !== 'function' || window.tncLenis) return;

    const pageWrapper = document.querySelector('.page-wrapper');
    const usesPageWrapper = desktop.matches && pageWrapper;
    const lenis = new window.Lenis({
      wrapper: usesPageWrapper ? pageWrapper : window,
      content: usesPageWrapper ? pageWrapper : document.documentElement,
      eventsTarget: usesPageWrapper ? pageWrapper : window,
      // .page-wrapper has a fixed viewport height, so ResizeObserver does not
      // reliably notice changes to its scrollHeight from late-loading content.
      naiveDimensions: Boolean(usesPageWrapper),
      autoRaf: true,
      anchors: true,
      smoothWheel: true,
      syncTouch: false,
      allowNestedScroll: true,
      duration: 1.4,
      lerp: 1.5
    });

    window.tncLenis = lenis;
    window.dispatchEvent(new CustomEvent('tnc:lenis-change', { detail: { lenis } }));

    const scrollWasAlreadyLocked = document.documentElement.hasAttribute('scroll-lock');
    if (scrollWasAlreadyLocked)
      lenis.stop();
  }

  function destroyLenis() {
    if (!window.tncLenis) return;
    window.tncLenis.destroy();
    window.tncLenis = null;
    window.dispatchEvent(new CustomEvent('tnc:lenis-change', { detail: { lenis: null } }));
  }

  function reinitLenis() {
    destroyLenis();
    initLenis();
  }

  initLenis();

  document.addEventListener('shopify:section:load', resizeLenis);
  window.addEventListener('load', resizeLenis);
  window.addEventListener('pageshow', resizeLenis);
  desktop.addEventListener('change', reinitLenis);
  reducedMotion.addEventListener('change', (event) => {
    if (event.matches) {
      destroyLenis();
    } else {
      initLenis();
    }
  });
})();

